export const HOME_PAGE = "/";
export const RESULTS_PAGE = "/results";
export const PRODUCT_PAGE = "/product";